if (!customElements.get('artist-inquiry-modal')) {
  class ArtistInquiryModal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.modal     = this.querySelector('[data-modal]');
      this.titleEl   = this.querySelector('[data-modal-title]');
      this.closeEls  = this.querySelectorAll('[data-modal-close]');
      this.formField = this.dataset.formField;

      if (!this.modal) return;

      this.onClick = this.onClick.bind(this);
      this.onKey   = this.onKey.bind(this);

      document.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKey);

      this.closeEls.forEach(el =>
        el.addEventListener('click', () => this.close())
      );
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKey);
    }

    onClick(e) {
      const trigger = e.target.closest('[data-artist-inquiry-open]');
      if (!trigger) return;

      e.preventDefault();

      if (this.titleEl && trigger.dataset.modalTitle) {
        this.titleEl.textContent = trigger.dataset.modalTitle;
      }

      this.prefill(trigger.dataset.modalValue);
      this.open();
    }

    open() {
      this.modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    onKey(e) {
      if (e.key === 'Escape') this.close();
    }

    waitForForm() {
      return new Promise(resolve => {
        const form = this.querySelector('form');
        if (form) return resolve(form);
        const observer = new MutationObserver(() => {
          const f = this.querySelector('form');
          if (f) {
            observer.disconnect();
            resolve(f);
          }
        });

        observer.observe(this, { childList: true, subtree: true });
      });
    }

    async prefill(value) {
      if (!value || !this.formField) return;
      const form = await this.waitForForm();
      const field = form.querySelector(`[name="${this.formField}"]`);
      if (!field) return;

      field.value = value;
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  customElements.define('artist-inquiry-modal', ArtistInquiryModal);
  
}
